<obg-m-dialog-layout
	*ngIf="!isLoginMfeEnable"
	[ngClass]="{'obg-m-login-with-dialog-sga-mode': sgaView }"
	test-id="login-modal"
	data-test-id="login-modal"
	#dialog
	[titleText]="(modalTitle$ | async) || defaultKey"
	[descriptionText]="(descriptionText$ | async) || undefined"
	[hideFooter]="hideFooter"
	[dialogId]="dialogId"
	[loading]="busy | async"
>
	<obg-m-login-container
		data-test-id="login-container"
		autoFocus
		[allLinksExternal]="allLinksExternal"
		[disallowLogin]="disallowLogin"
		[hideEmailPasswordLoginForDga]="isJurisdictionDga$ | async"
		(isSgaMode)="sgaView = $event"
		(loginSuccess)="loginSuccess.emit()"
		(registerButtonClick)="closeDialog()"
		(forgotPasswordButtonClick)="closeDialog()"
		(busy)="busy.next($event)"
	>
	</obg-m-login-container>
</obg-m-dialog-layout>
<ng-container *ngIf="isLoginMfeEnable && translations$ | async as translations">
	<account-login-fabric
		[translations]="translations"
		[error]="error"
		(closeModal)="closeDialog()"
		(rememberMeToggle)="rememberMeToggle($event.detail)"
		(registration)="routeLinks('registration')"
		(forgetPassword)="routeLinks('forgetPassword')"
		(loginValues)="loginValues($event.detail)"
	/>
</ng-container>
